import { CONTENT_ID_PAYLOAD, HANDOFF_PAYLOAD, INITIAL_PAYLOAD, languages } from '../constants'

export enum InitialContents {
  Advisor = 'advisor',
  ClaimRefund = 'claimRefund',
  Troubleshooting = 'troubleshooting',
}

export type InitialPayloadParams = {
  queueId?: string
}

export function getInitialPayload(
  initialContent?: string,
  params?: InitialPayloadParams,
  language?: string
) {
  const { queueId } = params as InitialPayloadParams
  switch (initialContent) {
    case InitialContents.Advisor:
      return `${HANDOFF_PAYLOAD}|${JSON.stringify({ queueId })}`
    case InitialContents.ClaimRefund:
      return language === languages.ENGLISH
        ? `${CONTENT_ID_PAYLOAD}|${JSON.stringify({ contentId: 'Claims' })}`
        : INITIAL_PAYLOAD
    case InitialContents.Troubleshooting:
      return language === languages.ENGLISH
        ? `${CONTENT_ID_PAYLOAD}|${JSON.stringify({ contentId: 'Troubleshooting Menu' })}`
        : INITIAL_PAYLOAD
    default:
      return INITIAL_PAYLOAD
  }
}
